const OptionOrderType = ({ index, type = 'number', prefix = '', className = '', style }: {
  index: number;
  type?: 'number' | 'letter';
  prefix?: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  const optionLabel: any = type === 'number' ? index + 1 : String.fromCharCode(65 + index);
  const label = prefix ? `${prefix}${optionLabel}` : optionLabel;
  const minLabelWidth = `${Math.max(3, String(label).length + 1)}ch`;

  const defaultClassName = 'min-w-9 h-fit  border border-grey-400 dark:border-grey-800  bg-grey-200 dark:bg-grey-900/50  grid place-items-center rounded-md overflow-hidden';
  return (
    <div
      style={{ minWidth: minLabelWidth }}
      className={ className || defaultClassName}>
      <span style={style} className="whitespace-nowrap px-1.5 font-Inter">{label}</span>
    </div>
  );
};

export default OptionOrderType;
